<template>
  <m-card
    :closed="!isOpen"
    headerText="Pension Tracker"
    class="absolute right-0 max-w-sm w-full shadow z-10"
  >
    <div class="flex flex-col space-y-4">
      <pension-tracker-member />
      <pension-tracker-pension-setup />
      <pension-tracker-pension-details />
    </div>
  </m-card>
</template>

<script>
import PensionTrackerMember from '@/app/modules/toolkit/pension/establishment/modules/workflow/components/pension-tracker/pension-tracker-member/pension-tracker-member.vue';
import PensionTrackerPensionSetup from '@/app/modules/toolkit/pension/establishment/modules/workflow/components/pension-tracker/pension-tracker-pension-setup/pension-tracker-pension-setup.vue';
import PensionTrackerPensionDetails from '@/app/modules/toolkit/pension/establishment/modules/workflow/components/pension-tracker/pension-tracker-pension-details/pension-tracker-pension-details.vue';

export default {
  name: 'pension-tracker-container',
  components: {
    PensionTrackerMember,
    PensionTrackerPensionSetup,
    PensionTrackerPensionDetails,
  },
  data: () => ({
    isOpen: false,
  }),
};
</script>

<style></style>
